<template>
  <div class="content-8__controlbar__item">
    <div class="c8-select">
      <div class="c8-select__title">
        <span class="c8-select__text">查看号码分布:</span>
      </div>
      <div class="c8-select__content">
        <a
          v-for="(item, index) in numList"
          :key="index"
          class="button-outline c8-select__content__item"
          :class="{'active': item.active }"
          @click="filterTableDataByNum(item)"
        >
          <span class="button-outline__text">号码{{ item.num }}</span>
        </a>
      </div>
    </div>
    <div class="c8-select">
      <div class="c8-select__title">
        <span class="c8-select__title__text">大小单双分布:</span>
      </div>
      <div class="c8-select__content">
        <a
          v-for="(tab, index) in filterTab"
          :key="index"
          class="button-outline c8-select__content__item"
          :class="{'active': tab.active }"
          @click="filterTableDataByTab(tab)"
        >
          <span class="button-outline__text">{{ tab.name }}</span>
        </a>
      </div>
      <div class="group-btn c8-select__content__item">
        <a class="button-primary disable item" @click="reduction">
          <span class="button-primary__text">还原</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HaoMaJhuShou',
  props: {
    lotteryType: {
      type: String,
      required: true,
      default: () => {
        console.error('HaoMaJhuShou required key "lotteryType"')
        return ''
      }
    }
  },
  data() {
    return {
      numList: [],
      filterTab: [
        { name: '单', active: false, type: 'isDan' },
        { name: '双', active: false, type: 'isShuang' },
        { name: '大', active: false, type: 'isDa' },
        { name: '小', active: false, type: 'isXiao' }
      ],
      activeNumList: [],
      isDanShuang: '',
      isDaXiao: '',
      activeLiangMianList: []
    }
  },
  created() {
    this.makeNumList()
  },
  methods: {
    makeNumList() {
      for (let i = 1; i <= 20; i++) {
        const obj = {}
        obj.num = i
        obj.active = false
        this.numList.push(obj)
      }
      this.filterNumListByType()
    },
    filterNumListByType() {
      const numberZero = {
        num: 0,
        active: false
      }

      switch (this.lotteryType) {
        case 'pk10':
          this.numList = this.numList.filter(item => item.num <= 10)
          break
        case '11x5':
          this.numList = this.numList.filter(item => item.num <= 11)
          break
        case 'ssc':
          this.numList = this.numList.filter(item => item.num <= 9)
          // 最前面補號碼0
          this.numList.unshift(numberZero)
          break
        default:
          console.warn('HaoMaJhuShou的filterNumListByType: 預設是快樂10分系列會有1到20碼')
          break
      }
    },
    filterTableDataByNum(item) {
      item.active = !item.active
      if (this.activeNumList.includes(item.num)) {
        const index = this.activeNumList.indexOf(item.num)
        this.activeNumList.splice(index, 1)
      } else {
        this.activeNumList.push(item.num)
      }
      this.closeTabActive()
      this.$store.commit('lottery/SET_NUMBER_LIST', this.activeNumList)
    },
    filterTableDataByTab(item) {
      this.closeNumActive()

      this.filterTab.forEach(tab => {
        if (item.name === tab.name) tab.active = !tab.active
        switch (item.name) {
          case '单':
            if (tab.name === '双') tab.active = false
            item.active ? this.isDanShuang = item.type : this.isDanShuang = ''
            break
          case '双':
            if (tab.name === '单') tab.active = false
            item.active ? this.isDanShuang = item.type : this.isDanShuang = ''
            break
          case '大':
            if (tab.name === '小') tab.active = false
            item.active ? this.isDaXiao = item.type : this.isDaXiao = ''
            break
          case '小':
            if (tab.name === '大') tab.active = false
            item.active ? this.isDaXiao = item.type : this.isDaXiao = ''
            break
        }
      })

      this.activeLiangMianList = []
      if (this.isDaXiao) {
        this.activeLiangMianList.push(this.isDaXiao)
      }
      if (this.isDanShuang) {
        this.activeLiangMianList.push(this.isDanShuang)
      }
      this.$store.commit('lottery/SET_LIANGMIAN_LIST', this.activeLiangMianList)
    },
    closeNumActive() {
      this.numList.forEach(item => {
        item.active = false
      })
      this.activeNumList = []
    },
    closeTabActive() {
      this.filterTab.forEach(tab => {
        tab.active = false
      })
      this.activeLiangMianList = []
      this.isDaXiao = ''
      this.isDanShuang = ''
    },
    reduction() {
      this.closeNumActive()
      this.closeTabActive()
      this.$store.commit('lottery/RESET_ACTIVE_LIST')
    }
  }
}
</script>
